/**
 * FrancIcon — Inline SVG that mirrors Lucide's stroke style for the
 * in-game currency symbol (₣). Drop-in replacement for `DollarSign` in
 * places that represent in-game ₣ (NOT real-money sweepstakes prizes).
 *
 * Usage: <FrancIcon className="h-3 w-3" />
 */
export default function FrancIcon({ className = '', size, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size || undefined}
      height={size || undefined}
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Vertical stem of the F */}
      <path d="M8 3v18" />
      {/* Top horizontal bar */}
      <path d="M8 3h11" />
      {/* Middle horizontal bar */}
      <path d="M8 12h8" />
      {/* The vertical stroke through the stem (what makes it ₣, not F) */}
      <path d="M5 16h6" />
    </svg>
  );
}
